<div class="legend-container">
  <ul>
    <li *ngFor="let d of data">
      <div><span [ngStyle]="{'background-color': d.color}"></span></div>
      <div>{{d.legend}}</div>
      </li>
  </ul>
</div>